import styled from '@emotion/styled';
import { theme } from '@kindur/components';

const Image = styled('img')`
  margin-top: 2rem;
  transform: translateY(3px);
  width: 333px;

  ${theme.breakpoints.tabletDown} {
    margin-top: 0;
    width: 100%;
  }
`;

export default Image;
